module.exports = __webpack_public_path__ + "img/_business_admin.5d43ef72.svg";